var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _path9, _path10, _defs, _defs2, _defs3, _path11, _defs4, _path12, _defs5, _path13, _defs6, _path14, _defs7, _defs8, _path15, _defs9, _defs10, _path16, _defs11, _path17, _defs12, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestomonial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "188.07px",
    height: "140px",
    viewBox: "0 0 188.07 140",
    style: {
      enableBackground: "new 0 0 188.07 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;stroke-dasharray:0,0,0,0,0,0;}\r\n\t.st2{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st4{clip-path:url(#SVGID_2_);}\r\n\t.st5{clip-path:url(#SVGID_4_);}\r\n\t.st6{clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st7{clip-path:url(#SVGID_8_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st8{clip-path:url(#SVGID_10_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st9{clip-path:url(#SVGID_12_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st10{opacity:0.9686;clip-path:url(#SVGID_14_);enable-background:new    ;}\r\n\t.st11{clip-path:url(#SVGID_16_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st12{opacity:0.9686;clip-path:url(#SVGID_18_);enable-background:new    ;}\r\n\t.st13{clip-path:url(#SVGID_20_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st14{clip-path:url(#SVGID_22_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st15{clip-path:url(#SVGID_24_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st16{stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.09,51.46c0-6.5,0-13,0-19.85c-1.25,0-2.51,0-3.77,0c-19.1,0-38.2-0.01-57.29,0.02 c-1.14,0-13.66-0.12-15.68-0.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.94,31.61c-6.55,0-13.41,0.03-20.28-0.02c-2.43-0.02-2.05,1.63-2.05,3.1c-0.01,7.99,0,15.97,0,24.3 c3.65,0,35.07,0,38.73,0L57.82,75l5.07-16.01l30.06,0.11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.73,56.58c-1.01-3.76-2.25-4.77-5.56-4.44c0.29,1.76,2.44,2.17,2.78,3.76c0.24,1.12,1.96,2.49-0.67,3.37 c-1.16-0.13-2.1-2.84-4.27-0.89c1.43,2.09,3.82,2.89,5.67,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.73,54.87c2.78,0.28,5.33,1.14,6.08,4.13c0.27,1.09,1.47,1.31,1.47,2.37"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.52,76.36c-2.73-1.96-5.15-4.33-7.17-7.02c-1.63-2.17-3.05-4.6-5.28-6.14c-2.23-1.55-5.63-1.88-7.44,0.15 c-1.03,1.15-1.31,2.82-1.1,4.34s0.86,2.95,1.53,4.34c3.7,7.71,8.26,15.32,15.18,20.35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.41,71.51c-3.54,2.13-5,6.49-5.79,10.55c-1.69,8.62-1.63,17.58,0.2,26.18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.28,68.25c-0.27,0.75-0.54,1.5-0.81,2.25c2.37,1.71,5.1,3.11,8.02,3.19c2.92,0.08,6.02-1.44,7.1-4.15 c-4.43,2.25-10.09,1.85-14.15-1.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.97,70.05c1.54-0.98,3.53-1.02,5.28-0.49s3.29,1.57,4.75,2.66c6.54,4.85,12.18,10.91,16.55,17.79 c1.55,2.44,2.98,5.27,2.39,8.1c-0.68,3.25-3.77,5.33-6.59,7.07c-2.06,1.27-4.47,2.58-6.78,1.85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.94,83.76c3.82,4.48,9.42,7.41,15.28,7.98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.62,92.07c-3.33,3.3-5.01,8.17-4.43,12.82c0.26,2.11,0.24,1.91,1.34,3.73"
  })), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.403 -0.9152 0.9152 0.403 37.218 155.533)",
    className: "st3",
    cx: 137.83,
    cy: 49.24,
    rx: 8.33,
    ry: 7.85
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.403 -0.9152 0.9152 0.403 44.7368 175.1788)",
    className: "st3",
    cx: 156.65,
    cy: 53.3,
    rx: 8.33,
    ry: 7.85
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.44,51.24c0.23-0.7,1.16-1.14,2.02-0.97c0.85,0.18,1.51,0.95,1.42,1.68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.21,61.61c-3.4-1.99-7.84-2.96-12.19-2.83c0.16,3.09,2.2,5.75,4.84,6.32c2.64,0.57,5.69-0.99,7.24-3.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_5_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M153.59,67.24c-2.49,0.9-6.83,1.09-10.5,0.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_7_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.61,66.81c-0.23,0.12-1.03,0.43-1.03,0.43L154.61,66.81z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_9_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M162.02,46.8c3.65,3.49,2.7,6.84,2.19,9.01c-1.31,5.47-6.41,9.26-9.61,11.01"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_11_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.14,67.55c-9.45-2.04-16.16-10.83-13.41-19.16c0.77-2.34,1.48-5.66,6.52-7.34"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_13_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_15_",
    points: "135.92,30.85 143.96,32.58 141.62,42.39 133.58,40.65  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M142.89,36.44c-1.18-1.76-2.53-3.28-4.26-4.47c-0.6-0.44-1.33-0.8-2.02-0.44 c-0.36,0.23-0.74,0.56-0.83,0.94c-0.66,2.32-0.83,4.23-0.36,6.48c0.22,0.76,0.44,1.97,0.95,2.08"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_17_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_19_",
    points: "158.67,35.2 169.03,37.43 166.51,47.96 156.16,45.73  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.82,46.75c1.43-0.4,3.34-0.81,3.99-2.26c-0.86,0.02-1.42-0.08-2.28-0.09 c1.57-0.58,3.03-1.52,4.08-2.85c-0.72,0.12-1.43,0.32-2.16,0.44c0.9-1.33,1.71-2.99,1.07-4.56 c-0.36-0.59-1.09-0.54-1.7-0.47c-2.59,0.67-4.92,2.01-7.21,3.35"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_21_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M158.58,39.74c-0.33,0.13-0.54,0.52-0.89,0.58c-0.15,0.02-0.3-0.02-0.43-0.07 c-1.28-0.46-2.27-1.49-3.27-2.42c-1-0.93-2.16-1.82-3.48-1.77c1.49,0.66,2.65,1.97,3.03,3.55 c-1.24-1.29-2.88-2.13-4.61-2.59c-1.73-0.46-3.27-0.4-5.07-0.31c-0.39,0.02-0.88,0-1.04-0.36"
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_23_",
    points: "133.7,27.2 171.49,35.36 162.06,74.88 124.27,66.72  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M164.86,39.26c1.26-0.26-0.78,0.09-1.34,0.59c-0.65,0.59-2.85,2.16-3.19,2.97 c-0.1,0.23-0.19,0.47-0.36,0.65c-0.37,0.39-0.98,0.37-1.5,0.28c-1.88-0.31-3.64-1.11-5.51-1.49 c-0.39-0.08-0.81-0.14-1.18,0.01c-0.62,0.24-1.01,0.99-1.67,1.03c-0.72,0.05-1.13-0.74-1.53-1.33 c-0.63-0.93-1.6-1.58-2.65-1.96c-1.05-0.38-2.19-0.48-3.33-0.49c-0.64,0-1.28,0.04-1.89-0.14c-0.14-0.04-0.28-0.1-0.37-0.21 c-0.1-0.13-0.12-0.29-0.13-0.46c-0.14-1.38-0.49-2.73-1.04-3.98c-0.14-0.31-0.82-1.1-1.12-1.26 c-0.93-0.48,1.09,0.6,1.09,1.25"
  })))))))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21.63,46.4c0.41-0.93,0.84-1.85,1.29-2.77c0.06-0.12,0.12-0.25,0.23-0.33c0.11-0.09,0.27-0.13,0.39-0.05 c0.09,0.05,0.13,0.15,0.17,0.25c0.42,1.01,0.83,2.03,1.28,3.05c1.28-0.19,2.6-0.16,3.87,0.08c0.19,0.04,0.43,0.12,0.43,0.31 c0.01,0.15-0.14,0.25-0.27,0.33c-1.06,0.64-2.12,1.28-3.19,1.92c0.03-0.05,0.06-0.1,0.09-0.15c0.46,0.9,0.93,1.8,1.39,2.71 c0.08,0.16,0.17,0.34,0.12,0.51c-0.06,0.22-0.32,0.35-0.56,0.33c-0.24-0.01-0.45-0.13-0.65-0.25c-0.88-0.54-1.65-1.23-2.46-1.94 c-1.15,0.88-2.3,1.77-3.45,2.65c-0.16,0.12-0.39,0.24-0.53,0.1c-0.07-0.07-0.08-0.19-0.07-0.29c0.04-1.29,0.09-2.63,0.76-3.75 c-0.58-0.31-1.16-0.63-1.69-1.02c-0.53-0.39-1-0.87-1.2-1.43c-0.08-0.1-0.02-0.26,0.09-0.33c0.11-0.07,0.25-0.09,0.38-0.1 c1.39-0.13,2.79-0.12,4.18,0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.99,45.75c0.41-0.93,0.84-1.85,1.29-2.77c0.06-0.12,0.12-0.25,0.23-0.33c0.11-0.09,0.27-0.13,0.39-0.05 c0.09,0.05,0.13,0.15,0.17,0.25c0.42,1.01,0.83,2.03,1.28,3.05c1.28-0.19,2.6-0.16,3.87,0.08c0.19,0.04,0.43,0.12,0.43,0.31 c0.01,0.15-0.14,0.25-0.27,0.33c-1.06,0.64-2.12,1.28-3.19,1.92c0.03-0.05,0.06-0.1,0.09-0.15c0.46,0.9,0.93,1.8,1.39,2.71 c0.08,0.16,0.17,0.34,0.12,0.51c-0.06,0.22-0.32,0.35-0.56,0.33c-0.24-0.01-0.45-0.13-0.65-0.25c-0.88-0.54-1.65-1.23-2.46-1.94 c-1.15,0.88-2.3,1.77-3.45,2.65c-0.16,0.12-0.39,0.24-0.53,0.1c-0.07-0.07-0.08-0.19-0.07-0.29c0.04-1.29,0.09-2.63,0.76-3.75 c-0.58-0.31-1.16-0.63-1.69-1.02c-0.53-0.39-1-0.87-1.2-1.43c-0.08-0.1-0.02-0.26,0.09-0.33s0.25-0.09,0.38-0.1 c1.39-0.13,2.79-0.12,4.18,0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M38.39,43.36c0.6-1.26,1.23-2.5,1.89-3.73c0.09-0.16,0.18-0.33,0.34-0.45c0.16-0.12,0.4-0.17,0.57-0.07 c0.13,0.07,0.19,0.21,0.25,0.33c0.61,1.37,1.23,2.74,1.88,4.11c1.88-0.25,3.82-0.22,5.69,0.1c0.28,0.05,0.62,0.17,0.63,0.42 c0.01,0.2-0.21,0.34-0.4,0.45c-1.56,0.87-3.12,1.73-4.68,2.6c0.04-0.07,0.09-0.14,0.13-0.21c0.68,1.22,1.36,2.43,2.05,3.65 c0.12,0.22,0.25,0.46,0.18,0.69c-0.09,0.3-0.47,0.47-0.82,0.45c-0.35-0.02-0.67-0.17-0.96-0.34c-1.3-0.72-2.42-1.66-3.61-2.61 c-1.69,1.19-3.38,2.39-5.07,3.58c-0.23,0.16-0.58,0.32-0.78,0.13c-0.11-0.1-0.11-0.25-0.11-0.39c0.05-1.73,0.13-3.55,1.11-5.06 c-0.85-0.42-1.71-0.85-2.48-1.38s-1.46-1.17-1.76-1.93c-0.12-0.14-0.03-0.35,0.13-0.45c0.16-0.1,0.36-0.12,0.56-0.14 c2.04-0.17,4.1-0.17,6.13,0.01"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.79,43.36c0.6-1.26,1.23-2.5,1.89-3.73c0.09-0.16,0.18-0.33,0.34-0.45c0.16-0.12,0.4-0.17,0.57-0.07 c0.13,0.07,0.19,0.21,0.25,0.33c0.61,1.37,1.23,2.74,1.88,4.11c1.88-0.25,3.82-0.22,5.69,0.1c0.28,0.05,0.62,0.17,0.63,0.42 c0.01,0.2-0.21,0.34-0.4,0.45c-1.56,0.87-3.12,1.73-4.68,2.6c0.04-0.07,0.09-0.14,0.13-0.21c0.68,1.22,1.36,2.43,2.05,3.65 c0.12,0.22,0.25,0.46,0.18,0.69c-0.09,0.3-0.47,0.47-0.82,0.45c-0.35-0.02-0.67-0.17-0.96-0.34c-1.3-0.72-2.42-1.66-3.61-2.61 c-1.69,1.19-3.38,2.39-5.07,3.58c-0.23,0.16-0.58,0.32-0.78,0.13c-0.11-0.1-0.11-0.25-0.11-0.39c0.05-1.73,0.13-3.55,1.11-5.06 c-0.85-0.42-1.71-0.85-2.48-1.38s-1.46-1.17-1.76-1.93c-0.12-0.14-0.03-0.35,0.13-0.45c0.16-0.1,0.36-0.12,0.56-0.14 c2.04-0.17,4.1-0.17,6.13,0.01"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.38,41.46c0.77-1.6,1.57-3.19,2.41-4.77c0.11-0.21,0.23-0.43,0.43-0.58c0.2-0.15,0.51-0.22,0.73-0.09 c0.16,0.09,0.25,0.26,0.32,0.42c0.78,1.75,1.56,3.5,2.39,5.25c2.4-0.32,4.87-0.28,7.25,0.13c0.36,0.06,0.8,0.21,0.81,0.53 c0.01,0.25-0.26,0.44-0.51,0.57c-1.99,1.11-3.98,2.21-5.96,3.32c0.06-0.09,0.11-0.18,0.17-0.26c0.87,1.56,1.74,3.11,2.61,4.67 c0.15,0.28,0.31,0.58,0.23,0.88c-0.11,0.38-0.6,0.6-1.04,0.58c-0.44-0.02-0.85-0.22-1.23-0.43c-1.66-0.92-3.09-2.12-4.6-3.34 c-2.16,1.53-4.31,3.05-6.47,4.58c-0.29,0.21-0.74,0.41-1,0.17c-0.14-0.13-0.14-0.32-0.14-0.5c0.07-2.22,0.17-4.54,1.42-6.46 c-1.09-0.54-2.18-1.09-3.17-1.76c-0.98-0.68-1.87-1.5-2.25-2.47c-0.15-0.18-0.04-0.44,0.16-0.57c0.2-0.13,0.46-0.16,0.71-0.18 c2.6-0.22,5.22-0.21,7.82,0.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestomonial);
export default __webpack_public_path__ + "static/media/testomonial.0f36de5bf8ef550808b4a540804a6a79.svg";
export { ForwardRef as ReactComponent };